package org.lennycodes.hldi.pages


import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.css.borderLeft
import com.varabyte.kobweb.compose.css.boxShadow
import com.varabyte.kobweb.compose.css.margin
import com.varabyte.kobweb.compose.css.textAlign
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.components.GradientButton
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.data.Program
import org.lennycodes.hldi.layouts.MainLayout
import org.lennycodes.hldi.styles.AboutHeroSectionStyle
import org.lennycodes.hldi.styles.AboutHeroTextStyle
import org.lennycodes.hldi.styles.AboutHeroTitleStyle
import org.lennycodes.hldi.styles.SectionWaveSvg

val allPrograms = listOf(
    Program(
        "food_security",
        "Food Security Program",
        "We promote sustainable access to nutritious food by supporting agricultural practices, strengthening livelihoods, and improving community resilience against food insecurity.",
        "🌾",
        "#96CEB4"
    ),

    Program(
        "child_protection",
        "Child Protection and Safeguarding Program",
        "We protect and promote the rights, safety, and well-being of children through safeguarding initiatives, awareness programs, prevention of abuse, and community-based protection systems.",
        "🛡️",
        "#FFEAA7"
    ),

    Program(
        "environment",
        "Environmental Conservation and Restoration Program",
        "We support environmental sustainability through conservation initiatives, ecosystem restoration, climate action, and community awareness to protect natural resources for future generations.",
        "🌍",
        "#4ECDC4"
    ),

    Program(
        "wash",
        "WASH Program",
        "We improve community health and dignity by increasing access to safe water, sanitation facilities, and hygiene education for vulnerable communities.",
        "💧",
        "#45B7D1"
    ),

    Program(
        "civic_governance",
        "Civic Education and Good Governance Program",
        "We empower communities through civic awareness, responsible citizenship, participation, accountability, and promotion of transparent and inclusive governance.",
        "🏛️",
        "#DDA0DD"
    )
)

@Composable
@Page
fun ProgramsPage() {
    MainLayout {
        // Hero
        Section(
            attrs = AboutHeroSectionStyle.toModifier()
                .then(
                    Modifier
                        .padding(50.px,20.px)
                        .width(100.vw)
                        .styleModifier {
                            property("margin-left", "calc(50% - 50vw)")
                            property("margin-right", "calc(50% - 50vw)")
                        }
                )
                .toAttrs()
        ) {
            H1(attrs = AboutHeroTitleStyle.toAttrs()) {
                Text("Our Programs")
            }
            P(attrs = AboutHeroTextStyle.toAttrs()) {
                Text("Comprehensive humanitarian programs designed to protect lives and build sustainable communities.")
            }
            SectionWaveSvg()
        }

        // Programs Grid
        Div(
            attrs = {
                style {
                    maxWidth(1100.px)
                    margin(0.px, autoLength) // centers content
                    padding(10.px, 10.px, 0.px, 10.px)
                }
            }
        ) {
            Section {
                allPrograms.forEach { program ->
                    Div(
                        attrs = {
                            id(program.id)
                            style {
                                borderLeft(width = 3.px, style = LineStyle.Dashed, color = HLDITheme.Colors.primary)
                                marginBottom(60.px)
                                padding(40.px)
                                backgroundColor(HLDITheme.Colors.white)
                                borderRadius(16.px)
                                boxShadow(0.px, 4.px, 16.px, color = Color.rgba(0, 0, 0, 0.08f))
                            }
                        }
                    ) {
                        Div(
                            attrs = {
                                style {
                                    display(DisplayStyle.Flex)
                                    gap(32.px)
                                    alignItems(org.jetbrains.compose.web.css.AlignItems.Start)
                                    flexWrap(FlexWrap.Wrap)
                                }
                            }
                        ) {
                            Div(
                                attrs = {
                                    style {
                                        fontSize(64.px)
                                        width(80.px)
                                        height(80.px)
                                        display(DisplayStyle.Flex)
                                        alignItems(AlignItems.Center)
                                        justifyContent(JustifyContent.Center)
                                        backgroundColor(HLDITheme.Colors.accent)
                                        borderRadius(50.percent)
                                    }
                                }
                            ) {
                                Text(program.icon)
                            }

                            Div(
                                attrs = {
                                    style {
                                        flex(1)
                                        minWidth(300.px)
                                    }
                                }
                            ) {
                                H2(
                                    attrs = {
                                        style {
                                            fontSize(32.px)
                                            color(HLDITheme.Colors.primary)
                                            marginBottom(16.px)
                                            fontFamily("Playfair Display", "serif")
                                        }
                                    }
                                ) {
                                    Text(program.title)
                                }

                                P(
                                    attrs = {
                                        style {
                                            fontSize(16.px)
                                            lineHeight("1.8")
                                            color(HLDITheme.Colors.text)
                                            marginBottom(24.px)
                                        }
                                    }
                                ) {
                                    Text(program.description)
                                }

                                GradientButton("Support This Program", "/get-involved")
                            }
                        }
                    }
                }
            }
        }
    }
}